import React from "react";
import { MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import { useTheme } from "../context/ThemeContext";

const Pagination = ({ pageNumber, setPageNumber, totalItem, parPage, showItem }) => {
  const { getButtonStyles } = useTheme();
  let totalPage = Math.ceil(totalItem / parPage);
  let startPage = pageNumber;

  let dif = totalPage - pageNumber;
  if (dif <= showItem) {
    startPage = totalPage - showItem;
  }
  let endPage = startPage < 0 ? showItem : showItem + startPage;

  if (startPage <= 0) {
    startPage = 1;
  }

  const createBtn = () => {
    const btns = [];
    for (let i = startPage; i < endPage; i++) {
      const isActive = pageNumber === i;
      btns.push(
        <li
          key={i}
          onClick={() => setPageNumber(i)}
          style={getButtonStyles(isActive ? "primary" : "secondary", isActive ? "white" : "default")}
          className={`w-[33px] h-[33px] rounded-full flex justify-center items-center cursor-pointer transition-all duration-200 ${
            isActive ? "shadow-lg scale-105 font-bold" : "hover:scale-105 hover:shadow-md"
          }`}>
          {i}
        </li>
      );
    }
    return btns;
  };

  return (
    <ul className="flex gap-3">
      {pageNumber > 1 && (
        <li
          onClick={() => setPageNumber(pageNumber - 1)}
          style={getButtonStyles("secondary", "default")}
          className="w-[33px] h-[33px] rounded-full flex justify-center items-center cursor-pointer hover:scale-105 hover:shadow-md transition-all duration-200">
          <MdOutlineKeyboardDoubleArrowLeft />
        </li>
      )}
      {createBtn()}
      {pageNumber < totalPage && (
        <li
          onClick={() => setPageNumber(pageNumber + 1)}
          style={getButtonStyles("secondary", "default")}
          className="w-[33px] h-[33px] rounded-full flex justify-center items-center cursor-pointer hover:scale-105 hover:shadow-md transition-all duration-200">
          <MdOutlineKeyboardDoubleArrowRight />
        </li>
      )}
    </ul>
  );
};

export default Pagination;
